import { Injectable } from '@angular/core';
import { Aircraftwatch, FlightWatchModelResponse } from 'src/app/models/flight-watch';

@Injectable({
  providedIn: 'root'
})
export class FlightWatchHelperService {

constructor() { }

    getSlashSeparationDisplayString(e1: any,e2: any){
        let str = (e1)?e1:"";
        str += (e1 && e2)?"/":"";
        str += (e2)?e2:"";
        return str;
    }
    getEmptyorDefaultStringText(str: string){
        return str == ""  ? "Unknown" : str ;
    }
    mapFlightWatchModelResponseToAircraftwatch(selectedPopUp: FlightWatchModelResponse) {
        var makemodelstr =
            this.getSlashSeparationDisplayString(
                selectedPopUp.make,
                selectedPopUp.model
            );
        makemodelstr =
            this.getEmptyorDefaultStringText(makemodelstr);
        let obj: Aircraftwatch = {
            customerInfoByGroupId: selectedPopUp.customerInfoByGroupId,
            tailNumber: selectedPopUp.tailNumber,
            atcFlightNumber: selectedPopUp.atcFlightNumber,
            aircraftTypeCode: selectedPopUp.aircraftTypeCode,
            isAircraftOnGround: selectedPopUp.isAircraftOnGround,
            flightDepartment: selectedPopUp.flightDepartment,
            aircraftMakeModel: makemodelstr,
            lastQuote: selectedPopUp.lastQuote,
            currentPricing: selectedPopUp.currentPricing,
            aircraftICAO: selectedPopUp.icaoAircraftCode,
            faaRegisteredOwner: selectedPopUp.faaRegisteredOwner,
            origin: selectedPopUp.departureICAO,
            destination: selectedPopUp.arrivalICAO,
            isJetNetEnabled: false,
            favoriteAircraft: selectedPopUp.favoriteAircraft,
            customerAircraftId: selectedPopUp.customerAircraftId,
        };

        return obj;
    }
}

